import { Directive } from '@angular/core';
@Directive({
  selector: '[fSearchContainer]',
  standalone: false
})
export class SearchContainerDirective {}
